import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Ahrefs Case Study | Canny';
const Description =
  'Read about how Ahrefs uses Canny to track feature requests and set customer expectations.';
const Image = 'https://canny.io/images/helmet-ahrefs-case-study.jpg';
const AhrefsUrl = 'https://canny.io/case-studies/ahrefs';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${AhrefsUrl}#webpage`,
    url: AhrefsUrl,
    name: 'Case Study: Ahrefs × Canny',
    description: 'How Ahrefs uses Canny to track feature requests and set customer expectations.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${AhrefsUrl}#article`,
    genre: 'Case Study',
    headline: 'How Ahrefs uses Canny to track feature requests and set customer expectations',
    description:
      'Ahrefs consolidated customer feedback from Intercom, Slack, and Sheets into Canny. Over 1,000 users submitted feedback, helping their team prioritize features more predictably.',
    inLanguage: 'en',
    url: AhrefsUrl,
    mainEntityOfPage: { '@id': `${AhrefsUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Ahrefs', url: 'https://ahrefs.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Ahrefs', item: AhrefsUrl },
  ]),
]);

export default class AhrefsLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: AhrefsUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
